import React, { useContext, useState } from 'react'
import './AddProduct.css'
import Field from '../../../components/Field/Field'
import Pill from '../../../components/Pill/Pill'
import Form from '../../../components/Form/Form'

import PlaceHolderFile from '../../../Assets/PlaceHolderFile.svg'
import DeleteButton from '../../../components/DeleteButton/DeleteButton'
import Notif from '../../../components/Notif/Notif'
import { DashboardContext } from '../../../Hooks/DashboardContext'
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import { storage } from '../../../firebase/firebase'
import { v4 } from 'uuid'
import { AddDoc } from '../../../firebase/utils'


const AddProduct = () => {

  

    const [Banner,setBanner]=useState(null)
    const [TopUne,setTopUne]=useState(null)
    const [Prix,setPrix]=useState(null)
    
    const {Message,setMessage,setloading,produit}=useContext(DashboardContext)


    
    
   

    function AddBanner (e,valideWidth,valideHeight) {
        
        const ImageCurrent=e.currentTarget.files
        const ComparedImage=new Image()
        ComparedImage.onload=()=>{
            if (ComparedImage.width===valideWidth && ComparedImage.height===valideHeight) {

                document.querySelector('#DelBanner').classList.remove('hide')
                setBanner(ImageCurrent)
                
            } else {
                setMessage('Image pas au bon format')
                document.querySelector('#ErrorDial').showModal()
                document.querySelector('#Banner').value=''
                
            }
        }
        ComparedImage.src=URL.createObjectURL(ImageCurrent[0])

       

    }
    function DeleteBanner (e) {
        document.querySelector('#DelBanner').classList.add('hide')
        document.querySelector('#Banner').value=''
        setBanner(null)
    }

    function AddTopUne (e,valideWidth,valideHeight) {
        const ImageCurrent=e.currentTarget.files
        const ComparedImage=new Image()
        ComparedImage.onload=()=>{

            if (ComparedImage.width===valideWidth && ComparedImage.height===valideHeight) {

                document.querySelector('#DelTopUne').classList.remove('hide')
                setTopUne(ImageCurrent)
            }
            else {

                setMessage('Image pas au bon format')

               document.querySelector('#ErrorDial').showModal()

                document.querySelector('#TopUne').value=''
                
            }
        }

        ComparedImage.src=URL.createObjectURL(ImageCurrent[0])
        
    }

    function DeleteTopUne (e) {

        document.querySelector('#DelTopUne').classList.add('hide')
        document.querySelector('#TopUne').value=''
        setTopUne(null)
       
    }

    function AjoutBanner (){
        let DownloadUrl=''

        if (Banner===null) {
            

            setMessage('Champ Banniere vide')

            document.querySelector('#ErrorDial').showModal()
        }
        else {
                if(produit===null) {
                    setMessage("La fiche du produit n'a pas de nom")

                    document.querySelector('#ErrorDial').showModal()

                }
                else {


                    return new Promise((resolu)=>{
                        const imageRef = ref(storage, `Banners/${produit.Nom}/${produit.Nom + v4()}`);
        
                        uploadBytes(imageRef, Banner[0]).then((snapshot) => {
                        getDownloadURL(snapshot.ref).then((url) => {
                          resolu(url)
                          DownloadUrl=url
                          setloading(true)
                          })
                        }
                      )
        
                    }).then(e=>AddDoc('Banners',{Nom:produit.Nom,imgUrl:DownloadUrl,isChecked:false}).then(
                        ()=>{
                            setloading(false)
                            
                            setMessage("Bannière bien ajouté")
    
                            document.querySelector('#ErrorDial').showModal()
                        }
                    )).catch(err=>console.log(err))
                }


        }


    }

    function AjoutTopUne (){
        let DownloadUrl=''

        if (TopUne===null) {
            

            setMessage('Champ Top Une vide')

            document.querySelector('#ErrorDial').showModal()
       
        
        }
        else {
            if(produit===null) {
                setMessage("Remplissez la fiche d'abord")
    
                document.querySelector('#ErrorDial').showModal()
    
            }
            else {

                if (produit.PrixInApp===undefined||null) {
                    setMessage('Champ Prix vide')
                    document.querySelector('#ErrorDial').showModal()
                    
                }
                else {
                    return new Promise((resolu)=>{
                        const imageRef = ref(storage, `TopUnes/${produit.Nom}/${produit.Nom + v4()}`);
    
                        uploadBytes(imageRef, TopUne[0]).then((snapshot) => {
                        getDownloadURL(snapshot.ref).then((url) => {
                        resolu(url)
                        DownloadUrl=url
                        setloading(true)
                        })
                        }
                    )
    
                    }).then(()=>AddDoc('TopUnes',{Nom:produit.Nom,Prix:produit.PrixInApp,imgUrl:DownloadUrl,isChecked:false}).then(
                        ()=>{
                        setloading(false);
                        setMessage("Produit à la une bien ajouté")
                        document.querySelector('#ErrorDial').showModal()}
                    )).catch(err=>console.log(err))
                }

            }

        }
        

    }



  return (
    <div id='Main' className='FadeIn'>
        
        <Notif Message={Message}/>
        <div id='CurrentActivity'>
                                        
                        <div className='heading'>
                            Ajouter un Produit
                        </div>
                        <div className='container formulaire'>

                            <Form/>
                        
                        </div>
                        
        </div>
        <div id='RightBar' >
                    <div className='container'>
                        <span>Ajoutez une bannière Pub</span>
                       
                        
                        <div className='FileUploader'> 
                            
                            <DeleteButton id={'DelBanner'} onClick={DeleteBanner} />
                            <label  htmlFor='Banner'>
                            <div className='box ratio169'><img src={Banner===null?PlaceHolderFile:URL.createObjectURL(Banner[0])} alt={Banner===null?"":"Banner"} /></div>
                            </label>
                            <input type="file" name="fichier" id="Banner" multiple onChange={e=>AddBanner(e,361,147)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
                        </div>
                        <div>
                            <div>Format Fichier</div>
                            <span>
                                L  = 361 px    /  H = 147 px
                            </span>
                        </div>
                        <Pill bgcolor={'#e8c133'} color={'#000'} text={'Ajouter bannière'} onclick={AjoutBanner}/>

                    </div>
                    <div className='container'>
                    <span>Ajoutez le produit à la une</span>
                    
                        <div className='FileUploader'>
                            <DeleteButton id={'DelTopUne'} onClick={DeleteTopUne}/>
                            <label htmlFor='TopUne'>
                            <div className='box ratio11'><img src={TopUne===null?PlaceHolderFile:URL.createObjectURL(TopUne[0])} alt={TopUne===null?"":"TopUne"} /></div>
                            </label>
                            <input type="file" name="fichier" id="TopUne" multiple onChange={e=>AddTopUne(e,116,116)} accept='image/gif, image/png, image/jpeg,image/webp, image/avif'/>
                        </div>
                        <div>
                            <div>Format Fichier</div>
                            <span>
                                L  = 116 px   /  H = 116 px
                            </span>
                        </div>
                        <div className='PrixProd'>
                            {false&&<Field typeInput={'number'} requis={true} FieldName={'Prix du produit'} className={'smallInput'} value={Prix} onchange={e=>setPrix()}/>}
                        </div>
                        <Pill bgcolor={'#e8c133'} color={'#000'} text={'Ajouter produit à la une'} onclick={AjoutTopUne}/>

                    </div>
        </div>
    </div>
  )
}

export default AddProduct